import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import { Button, Dropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import styled from 'styled-components';
import React, { useState } from 'react';
import * as styles from './topMenu.module.css';
import LinkComponent from '../../utils/linkComponent';
import { Link } from 'gatsby';
import CustomContext from '../../../custom-context';
import SubMenu from './subMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

const StyledLink = styled((props) => <LinkComponent {...props} />)`
	font-size: var(--font-size-base);
	margin-left: 1em;
	color: var(--secondary_6);
	padding: 0.3em;

	text-decoration: none;
	:hover {
		color: var(--link_color);
	}

	// mobile settings to match header font color
	@media (max-width: 1199.5px) {
		color: var(--secondary_6);
		font-weight: 600;
		margin-left: 0em;
		padding: 10px 0px;
		align-self: start;
	}

	@media (max-width: 768px) {
		color: var(--secondary_6);
		font-weight: 600;
		margin-left: 0em;
		padding: 10px 0px;
		align-self: start;
	}
`;

const NavStyled = styled.div`
	position: sticky;
	top: 0;
	z-index: 1001;
	background: ${(props) => props.bgColor || 'white'};

	.navbar .navbar-nav {
		color: var(--secondary_6);
		font-size: var(--font-size-base);
		align-items: center;
	}

	.topMenu {
		padding: 0;
		background: ${(props) => props.bgColor || 'white'};
	}

	.navbar-light .navbar-brand {
		color: var(--secondary_6);
	}

	.navbar-light .navbar-toggler {
		border-color: var(--secondary_7) !important;
		color: var(--secondary_2) !important;
	}
	.nav-link {
		margin-left: 1em;
		background-color: var(--primary);
		color: var(--secondary_8) !important;
		width: 7em;
		text-align: center;
	}

	.top-menu {
		line-height: 24px;
	}

	/* Dropdown styling */
	.dropdown-menu {
		background-color: var(--primary);
		border: 1px solid var(--secondary_7);
		border-radius: 4px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		right: 0;
		left: auto;
		min-width: 200px;
		position: absolute;
		z-index: 1050;
		transform: translateX(0);
	}

	/* Ensure dropdown container allows overflow */
	.dropdown {
		position: relative;
	}

	/* Override any container overflow that might clip the dropdown */
	.navbar-nav {
		overflow: visible !important;
	}

	.navbar-collapse {
		overflow: visible !important;
	}

	/* Ensure the main container allows overflow and remove padding */
	.container {
		overflow: visible !important;
		padding-left: 0 !important;
		padding-right: 0 !important;
	}

	/* Add proper padding to navbar content and ensure overflow */
	.navbar {
		padding-left: 1rem;
		padding-right: 1rem;
		overflow: visible !important;
	}

	/* SubMenu specific styling */
	.navbar-nav {
		position: relative;
	}

	/* Ensure submenu dropdowns are positioned correctly */
	.navbar-nav > * {
		position: relative;
	}

	/* Additional dropdown positioning fixes */
	.dropdown-menu-end {
		right: 0 !important;
		left: auto !important;
		transform: translateX(0) !important;
	}

	/* Ensure dropdown is not clipped by any parent */
	.dropdown-menu {
		position: absolute !important;
		z-index: 9999 !important;
		top: 100% !important;
	}

	.dropdown-item {
		color: white;
		padding: 8px 16px;
		font-size: var(--font-size-sm);
	}

	.dropdown-item:hover {
		background-color: var(--secondary_1);
		color: white;
	}

	.dropdown-item:focus {
		background-color: var(--secondary_1);
		color: white;
	}

	/* Override button styling to use secondary_1 color */
	.btn-primary {
		background-color: var(--secondary_1) !important;
		border-color: var(--secondary_1) !important;
		color: white !important;
	}

	.btn-primary:hover {
		background-color: var(--secondary_1) !important;
		border-color: var(--secondary_1) !important;
		color: white !important;
		opacity: 0.9;
	}

	.btn-primary:focus {
		background-color: var(--secondary_1) !important;
		border-color: var(--secondary_1) !important;
		color: white !important;
		box-shadow: 0 0 0 0.2rem rgba(0, 0, 0, 0.25) !important;
	}

	.btn-primary:active {
		background-color: var(--secondary_1) !important;
		border-color: var(--secondary_1) !important;
		color: white !important;
	}

	/* More specific selectors for better override */
	.navbar .btn-primary {
		background-color: var(--secondary_1) !important;
		border-color: var(--secondary_1) !important;
		color: white !important;
	}

	.navbar .btn-primary:hover {
		background-color: var(--secondary_1) !important;
		border-color: var(--secondary_1) !important;
		color: white !important;
		opacity: 0.9;
	}

	.navbar .btn-primary:focus {
		background-color: var(--secondary_1) !important;
		border-color: var(--secondary_1) !important;
		color: white !important;
		box-shadow: 0 0 0 0.2rem rgba(0, 0, 0, 0.25) !important;
	}

	.navbar .btn-primary:active {
		background-color: var(--secondary_1) !important;
		border-color: var(--secondary_1) !important;
		color: white !important;
	}

	/* Mobile-specific button styles */
	@media (max-width: 1199.5px) {
		.btn-primary,
		.navbar .btn-primary {
			background-color: var(--secondary_1) !important;
			border-color: var(--secondary_1) !important;
			color: white !important;
		}

		.btn-primary:hover,
		.navbar .btn-primary:hover {
			background-color: var(--secondary_1) !important;
			border-color: var(--secondary_1) !important;
			color: white !important;
			opacity: 0.9;
		}

		.btn-primary:focus,
		.navbar .btn-primary:focus {
			background-color: var(--secondary_1) !important;
			border-color: var(--secondary_1) !important;
			color: white !important;
			box-shadow: 0 0 0 0.2rem rgba(0, 0, 0, 0.25) !important;
		}

		.btn-primary:active,
		.navbar .btn-primary:active {
			background-color: var(--secondary_1) !important;
			border-color: var(--secondary_1) !important;
			color: white !important;
		}

		/* Dropdown positioning for mobile */
		.dropdown-menu {
			right: 0;
			left: auto;
			min-width: 200px;
			position: absolute;
			z-index: 1050;
			transform: translateX(0);
		}

		/* Ensure dropdown container allows overflow on mobile */
		.navbar-nav {
			overflow: visible !important;
		}

		.navbar-collapse {
			overflow: visible !important;
		}

		/* Top menu link styles to match header */
		.navbar .navbar-nav a {
			color: var(--secondary_6) !important;
			font-weight: 600;
		}

		/* SubMenu mobile styling */
		.navbar-nav > * {
			width: 100%;
		}
	}

	@media (max-width: 768px) {
		.btn-primary,
		.navbar .btn-primary {
			background-color: var(--secondary_1) !important;
			border-color: var(--secondary_1) !important;
			color: white !important;
		}

		.btn-primary:hover,
		.navbar .btn-primary:hover {
			background-color: var(--secondary_1) !important;
			border-color: var(--secondary_1) !important;
			color: white !important;
			opacity: 0.9;
		}

		.btn-primary:focus,
		.navbar .btn-primary:focus {
			background-color: var(--secondary_1) !important;
			border-color: var(--secondary_1) !important;
			color: white !important;
			box-shadow: 0 0 0 0.2rem rgba(0, 0, 0, 0.25) !important;
		}

		.btn-primary:active,
		.navbar .btn-primary:active {
			background-color: var(--secondary_1) !important;
			border-color: var(--secondary_1) !important;
			color: white !important;
		}

		/* Dropdown positioning for mobile */
		.dropdown-menu {
			right: 0;
			left: auto;
			min-width: 200px;
			position: absolute;
			z-index: 1050;
			transform: translateX(0);
		}

		/* Ensure dropdown container allows overflow on mobile */
		.navbar-nav {
			overflow: visible !important;
		}

		.navbar-collapse {
			overflow: visible !important;
		}

		/* Top menu link styles to match header */
		.navbar .navbar-nav a {
			color: var(--secondary_6) !important;
			font-weight: 600;
		}

		/* SubMenu mobile styling */
		.navbar-nav > * {
			width: 100%;
		}
	}
`;

/**
 * TopMenu component with submenu dropdown support
 *
 * Expected menu structure:
 * - For simple links: { title: "Link Title", path: "/path" }
 * - For submenu items: {
 *     title: "Menu Title",
 *     path: "/path",
 *     items: [
 *       { title: "Sub Item 1", path: "/sub-path-1" },
 *       { title: "Sub Item 2", path: "/sub-path-2" }
 *     ]
 *   }
 */
const TopMenu = (props) => {
	const { menu, bgColor, buttonShape } = props;
	const { user } = React.useContext(CustomContext);
	const isAuthenticated = !!user;
	const [expanded, setExpanded] = useState(false);

	// Debug: Log user data to check audienceSegment
	React.useEffect(() => {
		if (user) {
			console.log('TopMenu - Full user object:', user);
			console.log('TopMenu - user.audienceSegment:', user.audienceSegment);
			console.log('TopMenu - user.audience_segments:', user.audience_segments);
		}
	}, [user]);

	// These functions will be passed from the parent Header component
	const handleAuthClick = (mode) => {
		console.log('TopMenu handleAuthClick called with mode:', mode);
		props.onAuthClick && props.onAuthClick(mode);
	};
	const handleLogout = props.onLogout || (() => {});

	// Determine button class based on shape
	const buttonClass =
		buttonShape === 'rectangle' ? 'btn-rectangle' : 'btn-round';

	return (
		<NavStyled bgColor={bgColor}>
			<Navbar
				expand='xl'
				variant='light'
				className={styles.topMenu}
				style={{ background: bgColor }}
			>
				<Container>
					<Navbar.Brand style={{ cursor: 'pointer' }}></Navbar.Brand>
					<Navbar.Toggle aria-controls='basic-navbar-nav' />
					<Navbar.Collapse id='basic-navbar-nav' className='top-menu'>
						<Nav className='ms-auto'>
							{menu.map((item) => {
								// Check if item has submenu items
								if (item.items && item.items.length > 0) {
									return (
										<SubMenu
											key={item.title}
											menuItem={item}
											setExpanded={setExpanded}
										/>
									);
								} else {
									return (
										<StyledLink to={`${item.path}`} key={item.title}>
											{item.title}
										</StyledLink>
									);
								}
							})}
							{isAuthenticated ? (
								<>
									<span
										style={{
											color: 'white',
											marginLeft: '1em',
										}}
										className='text-light me-2'
									>
										Hi, {user?.firstName || user?.first_name}!
										{user?.audience_segments &&
											user.audience_segments.length > 0 && (
												<>
													{' '}
													Your view is{' '}
													{user.audience_segments[0]?.name ||
														user.audience_segments[0]?.attributes?.name ||
														'Academic Staff'}
												</>
											)}
									</span>
									<Button
										variant='outline-light'
										className={buttonClass}
										onClick={handleLogout}
										style={{ marginLeft: '1em' }}
									>
										LOGOUT
									</Button>
									<Button
										variant='outline-light'
										className={buttonClass}
										as={LinkComponent}
										to={`/members-directory/${user?.people_slug}/`}
										style={{
											marginLeft: '1em',
											textDecoration: 'none',
										}}
									>
										<FontAwesomeIcon
											icon={faUser}
											style={{ marginRight: '8px' }}
										/>
										My Profile
									</Button>
								</>
							) : (
								<>
									<Button
										variant='primary'
										className={buttonClass}
										as={Link}
										to='/login-help'
										style={{ marginLeft: '1em' }}
									>
										LOGIN
									</Button>
									<Button
										variant='primary'
										className={buttonClass}
										onClick={() => handleAuthClick('join')}
										style={{ marginLeft: '1em' }}
									>
										JOIN NOW
									</Button>
								</>
							)}
						</Nav>
					</Navbar.Collapse>
				</Container>
			</Navbar>
		</NavStyled>
	);
};

export default TopMenu;
